export default __webpack_public_path__ + "static/media/2106_30A.bf9d1db5.jpg";